import {
  Dropdown,
  DropdownItem,
  DropdownList,
  TableData,
  TableRow
} from '@cokitchen/cokitchen-components';
import { MonthlyStatementType } from 'models/statements.model';
import React, { useState } from 'react';
import { formatNumber } from 'utils/functions';

const PaymentTableRow = ({
  statement,
  handleDownload,
  filter
}: {
  statement: MonthlyStatementType;
  handleDownload?: (month: string, format: string) => void;
  filter: string;
}) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };
  return (
    <TableRow className='min-w-full payment_table'>
      <TableData className='lg:min-w-[100px] 	'>
        <p>
          <span className='mr-1'>{statement.month}</span>
          <span>{filter}</span>
        </p>
      </TableData>
      <TableData>{formatNumber(statement.total)}</TableData>
      <TableData>{formatNumber(statement.balance)}</TableData>
      <TableData className='flex items-end'>
        <Dropdown
          visible={isDropdownOpen}
          onClickOutside={() => setIsDropdownOpen(false)}
          content={
            <button
              onClick={toggleDropdown}
              className='bg-[#F2F2F2] rounded-full px-5 py-2 text-xs font-medium w-fit cursor-pointer'>
              Download
            </button>
          }>
          <DropdownList>
            {['pdf', 'xlsx'].map((format, index) => (
              <DropdownItem
                key={index}
                className='text-sm font-medium text-[#2e3031]'
                onClick={() => {
                  handleDownload?.(statement.month.trim(), format);
                  toggleDropdown();
                }}>
                {format.toUpperCase()}
              </DropdownItem>
            ))}
          </DropdownList>
        </Dropdown>
      </TableData>
    </TableRow>
  );
};

export default PaymentTableRow;
